import { createSSRApp } from 'vue';
import NotFoundPage from '@not-found/NotFoundPage.vue';
import type { PageData } from '@/types/index.mts';

export default function createApp<P extends PageData>(props: P) {
  const app = createSSRApp(NotFoundPage, props);
  return { app };
}
